export function triggerWindowResizeEvent () {
  let event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * 格式化文件大小
 * @author Jin
 * @Date 2026/03/17
 * @param {number} bytes - 文件大小（字节）
 * @returns {string} 格式化后的字符串（如 51.25 KB / 2.35 MB）
 */
export function formatFileSize(bytes) {
  if (bytes === 0 || !bytes) return '0 KB'
  
  const kb = bytes / 1024
  if (kb < 1024) {
    return kb.toFixed(2) + ' KB'
  }
  
  const mb = kb / 1024
  return mb.toFixed(2) + ' MB'
}

/**
 * 商户列表按显示名称排序
 * 中文按拼音、含数字名称按自然序（如 商户2 < 商户10）；返回新数组，不修改原始数据
 * @param {Array} list - 商户列表
 * @param {string} nameField - 显示名称字段（如 name / companyName）
 * @returns {Array} 排序后的新数组
 */
export function sortCompanyList (list, nameField = 'name') {
  if (!Array.isArray(list)) return []
  return list.slice().sort((a, b) =>
    String(a[nameField] || '').localeCompare(String(b[nameField] || ''), 'zh-Hans-CN', { numeric: true, sensitivity: 'base' })
  )
}


// WEBPACK FOOTER //
// ./src/utils/common.js